<template>
 <div class="mb-1">
   <div class="d-flex dkl-title-h4" style="background-color: #f3f1f1;">
     <h4>Aufwand</h4>
     <a class="dkl-btn btn-md rounded-circle pull-right" @click.prevent="modifyWork(null)" v-show="edit && !generateWork" href="#"><i class="fa fa-plus" aria-hidden="true"></i></a>
   </div>
   <div class="form-group row" v-show="works.length > 0">
     <div class="table-responsive col-md-12">
       <table class="table table-striped mb-0">
         <tbody>
         <tr v-for="(work, index) in first3Works" :key="index">
           <td class="keep-new-line">{{work.subject }}</td>
           <td>{{work.start_time}}</td>
           <td>{{resourceName(work.human_resource)}}</td>
           <td>{{work.chargable_hours}}</td>
           <td><div v-show="edit">
             <a class="dkl-btn rounded-circle pull-right" @click.prevent="modifyWork(work.id)" href="#"><i class="fa fa-pencil" aria-hidden="true"></i></a>
             <a class="dkl-btn rounded-circle pull-right" @click.prevent="confirmDeleteWork(work.id)" href="#"><i class="fa fa-trash" aria-hidden="true"></i></a>
           </div></td>
         </tr>
         </tbody>
       </table>
     </div>
     <div class="col-md-12" v-if="moreWorks"><a href="#" class="dkl-ml-075" @click.prevent="showList=true">mehr anzeigen</a></div>
   </div>
   <modal
     :title="modalTitle"
     v-show="generateWork"
     width="80%"
     ref="generateWork"
     custom-class="modify-work"
     @close ="generateWork = false">
     <div slot="body">
       <div class="form-group row mt-1" style="max-width: 1200px;">
         <div class="col-md-6">
           <label class="col-form-label">{{ $t('contract') }}</label>
           <select class="form-control select select-single select-work-contract" name="workContract" v-model="currentWork.contract" :disabled="!edit" v-select2>
             <option v-for="contract in workContracts" :value="contract.id">{{ contract.name }}</option>
           </select>
         </div>
         <div class="col-md-2">
           <label class="col-form-label">{{ $t('used') }}</label>
           <input type="number" step="0.1" class="form-control" name="usedTime" v-model="currentWork.worked_hours" :readonly="!edit" autocomplete="off" placeholder="Stunden">
         </div>
         <div class="col-md-2">
           <label class="col-form-label">{{ $t('chargeable') }}</label>
           <input type="number" step="0.1" class="form-control" name="chargeTime" v-model="currentWork.chargable_hours" :readonly="!edit" autocomplete="off" placeholder="Stunden">
         </div>
         <div class="col-md-2">
           <label class="col-form-label">{{ $t('amount') }}</label>
           <input type="number" step="0.1" class="form-control" name="chargeAmount" v-model="currentWork.chargable_euro" :readonly="!edit" autocomplete="off" placeholder="Betrag">
         </div>
       </div>
       <div class="form-group row">
         <div class="col-md-4">
           <label class="col-form-label">{{ $t('deadline') }}<span class="text-danger">*</span></label>
           <date-picker v-model="currentWork.start_time" :config="datetimeOptions" :readonly="!edit"></date-picker>
           <span class="error-message text-danger" v-show="v$.currentWork.start_time.$errors.length>0">{{ $t('required_field') }}</span>
         </div>
         <div class="col-md-2">
           <label class="col-form-label">{{ $t('staff') }}</label>
           <select class="form-control select select-single select-work-resource" name="workResource" v-model="currentWork.human_resource" :disabled="!edit" v-select2>
             <option v-for="resource in resources" :value="resource.id">{{ resource.user }}</option>
           </select>
         </div>
         <div class="col-md-6">
           <label class="col-form-label">{{ $t('effort') }} {{ $t('remarks') }}</label>
           <textarea class="form-control" name="workRemarks" v-model="currentWork.short_description"  :readonly="!edit"/>
         </div>
       </div>
     </div>
     <div slot="footer">
       <button type="button" class="btn btn-sm btn-success" @click.prevent="saveWork" :key="btnEnableKey" :disabled="btnDisabled">
         <i class='uil uil-message me-1'></i>{{ $t('effort') }} {{ $t('save') }}
       </button>
     </div>
   </modal>
   <modal
     title="WorksListModal"
     v-show="showList"
     width="100%"
     height="100%"
     ref="stepList"
     custom-class="work-list"
     @close ="showList = false">
     <div class="d-flex dkl-title-h4" style="background-color: #f3f1f1;" slot="header">
       <h4>Aufwände</h4>
     </div>
     <div slot="body">
       <div class="table-responsive col-md-12">
         <table class="table table-striped mb-0">
           <tbody>
           <tr v-for="(work, index) in works" :key="index" >
             <td>{{work.subject }}</td>
             <td>{{work.start_time}}</td>
             <td>{{resourceName(work.human_resource)}}</td>
             <td>{{work.chargable_hours}}</td>
             <td><div v-show="edit">
               <a class="dkl-btn rounded-circle pull-right" @click.prevent="modifyWork(work.id)" href="#"><i class="fa fa-pencil" aria-hidden="true"></i></a>
               <a class="dkl-btn rounded-circle pull-right" @click.prevent="confirmDeleteWork(work.id)" href="#"><i class="fa fa-trash" aria-hidden="true"></i></a>
             </div></td>
           </tr>
           </tbody>
         </table>
       </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button type="button" class="btn btn-secondary btn-rounded" @click.prevent="showList=false">schließen</button>
      </span>
   </modal>
 </div>
</template>

<script>
import {crmURL, service} from '@/utils/request.js';
import {CLOSED_STATUS, deepCopy, boolDisplay, initSelect2} from '@/utils/index.js';
import { newWork, newTodo } from '@/utils/enums.js';
import {mapState, mapMutations} from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import {required, requiredIf} from '@vuelidate/validators';
import Modal from "@/components/component/Modal";
import datePicker from 'vue-bootstrap-datetimepicker';
export default {
  name: "Works",
  components: {'modal': Modal, datePicker},
  props: {
    currentTodo: {
      type: Object,
      default: newTodo,
    },
  },
  data() {
    return {
      datetimeOptions: {
        format: 'DD.MM.YYYY',
        useCurrent: true,
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'top'
        }
      },
      currentWork: deepCopy(newWork),
      generateWork: false,
      works: [],
      showList: false,
      btnEnableKey: 1,
      btnDisabled: false,
      workContracts: [],
      resources: []
    }
  },
  computed: {
    ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id, edit: state => state.app.edit, language: state => state.app.language}),
    first3Works() {
      if (this.works.length > 3) return this.works.slice(0, 3)
      return this.works
    },
    moreWorks() {
      if (this.works.length > 3) return true
      return false
    },
    watchTodo() {
      return Object.assign({}, this.currentTodo)
    },
    currentResource() {
      const currentResourceList = this.resources.filter((resource) => resource.user.toUpperCase() === this.userName.toUpperCase())
      if (currentResourceList.length === 1) return currentResourceList[0].id
      return null
    },
    modalTitle() {
      return this.currentWork.id ? `${this.$t('effort')} ${this.$t('edit')}` : `${this.$t('effort')} ${this.$t('generate')}`
    },
  },
  watch: {
    watchTodo: {
      handler(newVal, oldVal) {
        if (newVal.id === oldVal.id) {
          if (newVal.status === 'Abgeschlossen' && oldVal.status !== 'Abgeschlossen') {
            this.confirmChangeDueDate()
            // this.confirmAddWork()
          }
        }
        if (newVal.crm_works && (newVal.id !== oldVal.id || newVal.crm_works.length !== this.works.length)) {
          this.getWorks()
        } else {
          this.works = []
        }
      },
      deep: true,
    }
  },
  updated() {
    this.steps = this.totalSteps
  },
  validations() {
    return {
      currentWork: {
        contract: {required, $lazy: true},
        start_time: {required, $lazy: true},
        human_resource: {required, $lazy: true},
        chargable_euro: {
          requiredIfNotChargableHours: requiredIf(!this.currentWork.chargable_hours)
        },
        chargable_hours: {
          requiredIfNotChargableEuro: requiredIf(!this.currentWork.chargable_euro)
        },
      },
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  mounted() {
    this.getResources()
  },
  methods: {
    ...mapMutations({
      'setEdit': "SET_EDIT"
    }),
    resourceName(resourceID) {
      const resourceList = this.resources.filter((resource) => resource.id === resourceID)
      if (resourceList.length === 1) return resourceList[0].user
      return 'K.A.'
    },
    confirmDeleteWork(id) {
      this.$confirm(
        {
          message: this.$t('confirm_delete_work'),
          button: {
            no: this.$t('no'),
            yes: this.$t('yes')
          },
          callback: confirm => {
            if (confirm) {
              this.deleteWork(id)
            }
          }
        }
      )
    },
    confirmAddWork(e, index) {
      this.$confirm(
        {
          message: this.$t('confirm_effort_to_task'),
          button: {
            no: this.$t('no'),
            yes: this.$t('yes')
          },
          callback: confirm => {
            if (confirm) {
              this.generateWork = true
            }
          }
        }
      )
    },
    confirmChangeDueDate(e) {
      console.log('dueDate')
      this.$confirm(
        {
          message: this.$t('confirm_deadline_to_today'),
          button: {
            no: this.$t('no'),
            yes: this.$t('yes')
          },
          callback: confirm => {
            if (confirm) {
              this.currentTodo.due_date = new Date()
            }
            this.confirmAddWork()
          }
        }
      )
    },
    deleteWork(id) {
      const workIndex = this.works.findIndex((work) => work.id === id)
      const todoWorkIndex = this.currentTodo.crm_works.findIndex((workID) => workID === id)
      service.request({
        url: `${crmURL}/rest/delete_work/${id}/`,
        method: 'DELETE',
        responseType: 'json',
      }).then(() => {
        this.$vToastify.success(`${this.$t("effort")} ${this.$t("deleted_successfully")}`)
        this.works.splice(workIndex, 1);
        this.currentTodo.crm_works.splice(todoWorkIndex, 1);
        this.$emit('workUpdated', this.currentTodo)
      })
    },
    modifyWork(id) {
      if (!id) {
        this.currentWork = deepCopy(newWork)
        this.currentWork.human_resource = this.currentResource
      } else {
        const workIndex = this.works.findIndex((work) => work.id === id)
        this.currentWork = this.works[workIndex]
      }
      $('.select-work-contract').val(this.currentWork.contract).trigger('change')
      $('.select-work-resource').val(this.currentWork.human_resource).trigger('change')
      this.generateWork = true
    },
    async saveWork(e) {
      const isValid = await this.v$.currentWork.$validate()
      if (!isValid) {
        this.$vToastify.error(this.$t('complete_missing_fields'))
        return
      }
      this.btnDisabled = true
      let url = `${crmURL}/rest/work/`
      let created = true
      if (this.currentWork.id == null) {
        this.currentWork.subject = this.currentTodo.description
        this.currentWork.customer = this.account.crmID
      } else {
        url = `${crmURL}/rest/update_work/${this.currentWork.id}/`
        created = false
      }
      await service.request({
        url: url,
        method: 'POST',
        responseType: 'json',
        data: this.currentWork
      }).then((response) => {
        if (!this.currentTodo.crm_works) this.currentTodo.crm_works = []
        if (created) {
          this.currentTodo.crm_works.push(response.data.id)
          this.works.push(response.data)
        } else {
          const workIndex = this.works.findIndex((work) => work.id === this.currentWork.id)
          this.works[workIndex] = response.data
        }
        this.generateWork = false
        this.currentWork = deepCopy(newWork)
        this.v$.$reset()
        this.$emit('workUpdated', this.currentTodo)
      }).catch(function(err) {
        console.log(err)
      })
      this.btnDisabled = false
    },
    async getResources() {
      const contractsPromise = service.request({
        url: `${crmURL}/rest/get_valid_contracts/${this.account.crmID}/`,
        method: 'GET',
        responseType: 'json',
      })
      const hrPromise = service.request({
        url: `${crmURL}/rest/hr_list/`,
        method: 'GET',
        responseType: 'json',
      })
      Promise.all([contractsPromise, hrPromise]).then((responses) => {
        this.workContracts = responses[0].data;
        this.resources = responses[1].data;
        initSelect2();
      }).catch(function(err) {
        console.log(err)
      })
    },
    async getWorks() {
      const workParams = this.currentTodo.crm_works.map((workID) => `crm_ids=${workID}`)
      await service.request({
        url: `${crmURL}/rest/get_works?${workParams.join('&')}`,
        method: 'GET',
        responseType: 'json',
      }).then((response) => {
        this.works = response.data;
      }).catch(function(err) {
        console.log(err)
      })
    },
  }
}
</script>

<style>
.dkl-ml-075 {
  margin-left: 0.75rem;
}

.dkl-scale {
  float: right;
  background-color: gray;
  width: 100%;
  height: 100px;
  line-height: 100px;
  animation: main 3s;
  transform-origin: 0% 0%;
}

@keyframes main {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

.modify-work {
  left: -800px!important;
}

.work-list .close,
.modify-work .close {
  position: inherit!important;
}
</style>
